import Reports from '../component/Reports';
import Report404 from '../component/Report404';
let Routes = [
  {
    title: 'user',
    path: '/user/report/:personId/:docType',
    component: Reports,
    isProtectedRoute: false
  },
  {
    path: '*',
    exact: true,
    component: Report404,
    is404: true
  }
];

export default Routes;
